import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  sendOtpThunk,
  verifyOtpThunk,
  resetOtpState,
} from "../features/user/userSlice";
import { base_url } from "../utils/axiosConfig";
import { registerPush } from "../registerPush";
const PUBLIC_VAPID_KEY = "BEy2MTbMdqya2WIMBbM4xmZSb-mtcVPWLUyhs038xPAVlY8-BW2yUkNCagWyCErwHCWxeiX1g9qsRznktqtUDxY";
const LoginSignUpModal = () => {
  const dispatch = useDispatch();

  // Safe destructuring with fallback values
  const authState = useSelector((state) => state.auth || {});
  const {
    isLoadingOtp: isLoading,
    isSuccess,
    isError,
    message,
    verifyOtpData,
  } = authState;

  const [step, setStep] = useState(1); // 1 = input, 2 = OTP
  const [form, setForm] = useState({ mobile: "", email: "" });
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [timer, setTimer] = useState(60);
  const [resendEnabled, setResendEnabled] = useState(false);
  const [showFormError, setShowFormError] = useState(false);
  const [formError, setFormError] = useState("");
const [emailExists, setEmailExists] = useState(false);
const [emailChecked, setEmailChecked] = useState(false);
const [isCheckingEmail, setIsCheckingEmail] = useState(false);
  const otpRefs = useRef([]);
  const modalRef = useRef(null);
const checkEmailExists = async (email) => {
  try {
    setIsCheckingEmail(true); // 👈 START loader

    const res = await fetch(`${base_url}user/check-email-exists`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();

    if (data?.exists && data?.data?.mobile) {
      setEmailExists(true);
      setForm((prev) => ({
        ...prev,
        mobile: data.data.mobile.replace("+91", ""),
      }));
    } else {
      setEmailExists(false);
    }

    setEmailChecked(true);
  } catch (err) {
    setEmailExists(false);
    setEmailChecked(true);
  } finally {
    setIsCheckingEmail(false); // 👈 STOP loader
  }
};

  /* ---------------- RESET ON MODAL SHOW ---------------- */
  useEffect(() => {
    const modalEl = document.getElementById("loginSignUpModal");
    
    if (modalEl) {
      // Reset everything when modal is shown
      const handleShowModal = () => {
        dispatch(resetOtpState());
        setStep(1);
        setForm({ mobile: "", email: "" });
        setOtp(new Array(6).fill(""));
        setTimer(60);
        setResendEnabled(false);
        setShowFormError(false);
        setFormError("");
      };

      modalEl.addEventListener("show.bs.modal", handleShowModal);
      
      return () => {
        modalEl.removeEventListener("show.bs.modal", handleShowModal);
      };
    }
  }, [dispatch]);

  /* ---------------- TIMER ---------------- */
  useEffect(() => {
    if (step === 2 && timer > 0) {
      const interval = setInterval(() => {
        setTimer((t) => t - 1);
      }, 1000);

      return () => clearInterval(interval);
    }

    if (timer === 0) {
      setResendEnabled(true);
    }
  }, [step, timer]);

  /* -------- SEND OTP SUCCESS -> SHOW OTP -------- */
  useEffect(() => {
    if (isSuccess && step === 1) {
      setOtp(new Array(6).fill(""));
      setTimer(60);
      setResendEnabled(false);
      setShowFormError(false);
      setFormError("");
      setStep(2);
    }
  }, [isSuccess, step]);

  /* -------- AUTO FOCUS FIRST OTP -------- */
  useEffect(() => {
    if (step === 2) {
      setTimeout(() => {
        if (otpRefs.current[0]) {
          otpRefs.current[0].focus();
        }
      }, 300); // Slightly longer delay for better UX
    }
  }, [step]);

  /* -------- VERIFY OTP SUCCESS -------- */
  useEffect(() => {
    if (verifyOtpData?.token) {
      localStorage.setItem("customer", JSON.stringify(verifyOtpData));

      const modalEl = document.getElementById("loginSignUpModal");
      const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
      modalInstance?.hide();

      // Show success message before reload
      setTimeout(() => {
        window.location.reload();
      }, 500);

      dispatch(resetOtpState());
    }
  }, [verifyOtpData, dispatch]);

  /* ---------------- VALIDATION HELPERS ---------------- */
  const validateForm = () => {
    setShowFormError(false);
    setFormError("");

    if (!form.mobile.trim()) {
      setFormError("Please enter mobile number or email");
      setShowFormError(true);
      return false;
    }

    if (form.mobile && form.mobile.length !== 10) {
      setFormError("Please enter a valid 10-digit mobile number");
      setShowFormError(true);
      return false;
    }
if(!form?.email){
      setFormError("Please enter a valid email address");
      setShowFormError(true);
      return false;
}
    if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) {
      setFormError("Please enter a valid email address");
      setShowFormError(true);
      return false;
    }

    return true;
  };

  /* ---------------- HANDLERS ---------------- */
  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) return;
    if (value.length <= 10) {
      setForm({ ...form, mobile: value });
      if (showFormError) {
        setShowFormError(false);
        setFormError("");
      }
    }
  };

 // REPLACE
const handleChange = (e) => {
  const { name, value } = e.target;
  setForm({ ...form, [name]: value });

  // ADD this line ONLY
  if (name === "email" && /^\S+@\S+\.\S+$/.test(value)) {
    checkEmailExists(value);
  }

  if (showFormError) {
    setShowFormError(false);
    setFormError("");
  }
};



const handleSendOtp = async () => {
  if (!validateForm()) return;

  // 1️⃣ Wait for push subscription to save
  const subscribed = await registerPush(form.email,`+91${form.mobile}`, PUBLIC_VAPID_KEY);

  // 2️⃣ THEN send OTP
  dispatch(
    sendOtpThunk({
      mobile: form.mobile ? `+91${form.mobile}` : undefined,
      email: form.email || undefined,
    })
  );
};

  const handleResendOtp = () => {
    if (!resendEnabled) return;

    dispatch(
      sendOtpThunk({
        mobile: form.mobile ? `+91${form.mobile}` : undefined,
        email: form.email || undefined,
      })
    );

    setTimer(60);
    setResendEnabled(false);
    
    // Auto focus first OTP input after resend
    setTimeout(() => {
      if (otpRefs.current[0]) {
        otpRefs.current[0].focus();
      }
    }, 100);
  };

  const handleVerifyOtp = (enteredOtp) => {
    if (enteredOtp.length !== 6) return;
    
    dispatch(
      verifyOtpThunk({
        mobile: form.mobile ? `+91${form.mobile}` : undefined,
        email: form.email || undefined,
        otp: enteredOtp,
      })
    );
  };

  /* ---------------- OTP INPUT ---------------- */
  const handleOtpChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto-focus next input
    if (value && index < 5) {
      setTimeout(() => {
        if (otpRefs.current[index + 1]) {
          otpRefs.current[index + 1].focus();
        }
      }, 10);
    }

    // Auto-submit when all OTP digits are entered
    if (newOtp.every(digit => digit !== "") && newOtp.join("").length === 6) {
      handleVerifyOtp(newOtp.join(""));
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      otpRefs.current[index - 1]?.focus();
    }
    
    // Allow Enter key to trigger OTP verification if all digits are filled
    if (e.key === "Enter" && otp.every(digit => digit !== "")) {
      handleVerifyOtp(otp.join(""));
    }
  };

  
  /* ---------------- RENDER LOADER ---------------- */
  const renderLoader = () => (
    <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75" 
         style={{ zIndex: 9999, backdropFilter: "blur(3px)" }}>
      <div className="text-center">
        <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3 text-muted">Processing...</p>
      </div>
    </div>
  );

  /* ---------------- JSX ---------------- */
  return (
    <>
      {/* Full-page loader */}
      {isLoading && renderLoader()}
      
      {/* Modal */}
      <div
        className="modal fade"
        id="loginSignUpModal"
        tabIndex="-1"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            {/* HEADER */}
            <div className="modal-header border-bottom">
              <h5 className="modal-title fw-bold">Welcome to Shoplintic</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            {/* BODY */}
            <div className="modal-body p-4">
              {/* STEP 1 - MOBILE/EMAIL INPUT */}
              {step === 1 && (
                <>
                  <p className="text-center text-muted mb-4">
                    Login / Sign up using Mobile or Email
                  </p>
    {/* Email Input */}
                  <div className="mb-4">
                    <label htmlFor="emailInput" className="form-label small text-muted">
                      Email Address
                    </label>
                    <input
                      id="emailInput"
                      type="email"
                      name="email"
                      placeholder="Enter your email"
                      className="form-control py-2"
                      value={form.email}
                      onChange={handleChange}
                    />
                  </div>
                  {isCheckingEmail && (
  <div className="d-flex align-items-center mt-1 text-muted small">
    <span
      className="spinner-border spinner-border-sm me-2"
      role="status"
    />
    Checking email...
  </div>
)}
                  {/* Mobile Input */}
                  <div className="mb-3">
                    <label htmlFor="mobileInput" className="form-label small text-muted">
                      Mobile Number <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <span className="input-group-text bg-light">+91</span>
                      <input
                        id="mobileInput"
                        type="text"
                        className="form-control py-2"
                        placeholder="Enter 10-digit mobile"
                        value={form.mobile}
                        onChange={handleMobileChange}
                        maxLength={10}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        autoFocus
                          disabled={emailExists}  
                      />
                    </div>
                  </div>

                  {/* OR Divider */}
                  {/* <div className="position-relative my-4">
                    <hr />
                    <span className="position-absolute top-50 start-50 translate-middle bg-white px-3 text-muted small">
                      OR
                    </span>
                  </div> */}

              

                  {/* Form Error */}
                  {showFormError && (
                    <div className="alert alert-danger py-2 mb-3" role="alert">
                      <small>{formError}</small>
                    </div>
                  )}

                  {/* Redux Error */}
                  {isError && message && (
                    <div className="alert alert-danger py-2 mb-3" role="alert">
                      <small>{typeof message === 'string' ? message : message?.message || "Something went wrong"}</small>
                    </div>
                  )}

                  {/* Send OTP Button */}
                  <button
                    className="btn btn-primary w-100 py-2 fw-medium"
                    onClick={handleSendOtp}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Sending OTP...
                      </>
                    ) : (
                      "Send OTP"
                    )}
                  </button>

                  {/* Terms Note */}
                  <p className="text-center text-muted small mt-3 mb-0">
                    By continuing, you agree to our Terms & Privacy Policy
                  </p>
                </>
              )}

              {/* STEP 2 - OTP VERIFICATION */}
              {step === 2 && (
                <>
                  <p className="text-center mb-1">
                    Enter 6-digit OTP
                  </p>
                  <p className="text-center text-muted small mb-4">
                    {/* Sent to {form.mobile ? `+91 ${form.mobile}` : form.email} */}
                    OTP sent to {form.email}
                  </p>

                  {/* OTP Inputs */}
                  <div className="d-flex justify-content-center gap-2 mb-4">
                    {otp.map((digit, index) => (
                      <input
                        key={index}
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        autoComplete="one-time-code"
                        maxLength={1}
                        className="form-control text-center border-primary"
                        style={{
                          width: "45px",
                          height: "55px",
                          fontSize: "24px",
                          fontWeight: "bold",
                          borderRadius: "8px"
                        }}
                        value={digit}
                        ref={(el) => (otpRefs.current[index] = el)}
                        onChange={(e) => handleOtpChange(e.target.value, index)}
                        onKeyDown={(e) => handleOtpKeyDown(e, index)}
                        onFocus={(e) => e.target.select()}
                      />
                    ))}
                  </div>

                  {/* Timer/Resend */}
                  <div className="text-center mb-4">
                    {resendEnabled ? (
                      <button
                        className="btn btn-link text-decoration-none p-0"
                        onClick={handleResendOtp}
                        disabled={isLoading}
                      >
                        Resend OTP
                      </button>
                    ) : (
                      <p className="text-muted small mb-0">
                        Resend OTP in <span className="fw-bold">{timer}s</span>
                      </p>
                    )}
                  </div>

                  {/* Redux Error */}
                  {isError && message && (
                    <div className="alert alert-danger py-2 mb-3" role="alert">
                      <small>{typeof message === 'string' ? message : message?.message || "Invalid OTP"}</small>
                    </div>
                  )}

                  {/* Action Buttons */}
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-outline-secondary flex-fill"
                      onClick={() => {
                        dispatch(resetOtpState());
                        setStep(1);
                        setOtp(new Array(6).fill(""));
                        setTimer(60);
                        setResendEnabled(false);
                      }}
                      disabled={isLoading}
                    >
                      Change Email
                    </button>
                    
                    <button
                      className="btn btn-primary flex-fill"
                      onClick={() => handleVerifyOtp(otp.join(""))}
                      disabled={otp.some(digit => digit === "") || isLoading}
                    >
                      {isLoading ? "Verifying..." : "Verify OTP"}
                    </button>
                  </div>
                </>
              )}
            </div>

            {/* FOOTER */}
            <div className="modal-footer border-top text-center">
              <small className="text-muted">
                Need help? <a href="/contact" className="text-decoration-none">Contact Support</a>
              </small>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginSignUpModal;